// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { SystemListModel } from "@tps/App/Services/SystemListService";
import { Draft } from "immer";

export interface xShippingTermsState {
    isLoading: boolean;
    data: SystemListModel | null;
}

const initialState: xShippingTermsState = {
    isLoading: false,
    data: {},
};

const reducer = {
    "xShippingTerms/BeginLoadShippingTerms": (
        draft: Draft<xShippingTermsState>
    ) => {
        draft.data = {};
        draft.isLoading = true;
    },
    "xShippingTerms/CompleteLoadShippingTerms": (
        draft: Draft<xShippingTermsState>,
        action: { data: SystemListModel },
    ) => {
        draft.data = action.data;
        draft.isLoading = false;
    },
};

const xShippingTerms = createTypedReducerWithImmer(initialState, reducer);
(reducers as any).xShippingTerms = xShippingTerms;

export type xShippingTerms = {
    xShippingTerms: xShippingTermsState;
} & ApplicationState;

type xShippingTermsActionsReducers = {
    [key: string]: typeof xShippingTerms;
};

export type xShippingTermsActions = Parameters<xShippingTermsActionsReducers[keyof xShippingTermsActionsReducers]>[1];